// extracted by mini-css-extract-plugin
export default {"quantity_container":"fJ","hiddenflavorstring":"gJ","loadingLine":"hJ","productimgwrap":"iJ","productimg":"jJ","circlepic":"kJ","productinfo":"lJ","grey_x":"mJ","cartrow":"nJ","bold":"oJ","title":"pJ","blue":"qJ","strike":"rJ","flexgap":"sJ","flavorstring":"tJ","nodecorate":"uJ","flavorstring_link":"vJ","rdstring":"wJ","removeditemblock":"xJ","removed_heading":"yJ","removed_text":"zJ","addback":"AJ"};
    if(module.hot) {
      // 1713211521452
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  